var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicationAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Application Add",
    clipPath: "url(#clip0_13_8622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "application-add--application-new-add-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.3572 0.535721H1.6072C1.32303 0.535721 1.05051 0.648603 0.849581 0.849535C0.648649 1.05047 0.535767 1.32299 0.535767 1.60715V5.35715C0.535767 5.64131 0.648649 5.91383 0.849581 6.11476C1.05051 6.3157 1.32303 6.42858 1.6072 6.42858H5.3572C5.64136 6.42858 5.91388 6.3157 6.11481 6.11476C6.31574 5.91383 6.42862 5.64131 6.42862 5.35715V1.60715C6.42862 1.32299 6.31574 1.05047 6.11481 0.849535C5.91388 0.648603 5.64136 0.535721 5.3572 0.535721Z",
    stroke: "#2B5CE6",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.393 8.57144H9.64296C9.3588 8.57144 9.08628 8.68432 8.88535 8.88526C8.68442 9.08619 8.57153 9.35871 8.57153 9.64287V13.3929C8.57153 13.677 8.68442 13.9496 8.88535 14.1505C9.08628 14.3514 9.3588 14.4643 9.64296 14.4643H13.393C13.6771 14.4643 13.9496 14.3514 14.1506 14.1505C14.3515 13.9496 14.4644 13.677 14.4644 13.3929V9.64287C14.4644 9.35871 14.3515 9.08619 14.1506 8.88526C13.9496 8.68432 13.6771 8.57144 13.393 8.57144Z",
    stroke: "#2B5CE6",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.3572 8.57144H1.6072C1.32303 8.57144 1.05051 8.68432 0.849581 8.88526C0.648649 9.08619 0.535767 9.35871 0.535767 9.64287V13.3929C0.535767 13.677 0.648649 13.9496 0.849581 14.1505C1.05051 14.3514 1.32303 14.4643 1.6072 14.4643H5.3572C5.64136 14.4643 5.91388 14.3514 6.11481 14.1505C6.31574 13.9496 6.42862 13.677 6.42862 13.3929V9.64287C6.42862 9.35871 6.31574 9.08619 6.11481 8.88526C5.91388 8.68432 5.64136 8.57144 5.3572 8.57144Z",
    stroke: "#2B5CE6",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.5179 6.42858V0.535721",
    stroke: "#2B5CE6",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.57153 3.48215H14.4644",
    stroke: "#2B5CE6",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_8622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationAdd);
export default __webpack_public_path__ + "static/media/Application Add.35abe7b5617d2e567fd8b9b221772d75.svg";
export { ForwardRef as ReactComponent };